import React, {Suspense} from 'react';
import {Switch} from 'react-router-dom';
import {NotificationsPage} from './components/NotificationsPage';
import {LayoutSplashScreen, ContentRoute} from '../../../_metronic/layout';

export default function NotificationsPageContainer() {
  return (
    <Suspense fallback={<LayoutSplashScreen/>}>
      <Switch>
        <ContentRoute path="/notifications-center" component={NotificationsPage}/>
      </Switch>
    </Suspense>
  );
}
